import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toggleDetails} from '../../../actions/navOptions';

class SpotDetailsButton extends Component {

  buttonStyleByResponsiveness() {
    const {isReservedByMe, isMobileDevice} = this.props;
    return isMobileDevice && isReservedByMe ? 'visible-xs-inline-block' : 'btn-block';
  }

  render() {
    const {spotInfoDetailedView} = this.props;

    return (
      <a className={`btn btn-default btn-details btn-lg ${this.buttonStyleByResponsiveness()}`}
         onClick={() => {this.props.toggleDetails(spotInfoDetailedView);}}
      >
        {spotInfoDetailedView ? "Close" : "Details"}
      </a>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    spotInfoDetailedView: state.navOptions.spotInfoDetailedView
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({toggleDetails}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SpotDetailsButton);



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/ParkingSpotInfoFooter/SpotDetailsButton.js